/* Depleted Dad advertorial — gentle scroll reveal (idempotent, reduced-motion safe) */
(function () {
  if (window.__ddReveal) return;
  window.__ddReveal = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function bind() {
    var els = document.querySelectorAll('.dd__rise:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState !== 'loading') bind();
  else document.addEventListener('DOMContentLoaded', bind);
  // re-bind inside Shopify's theme editor when sections re-render
  document.addEventListener('shopify:section:load', bind);
})();
